angular.module('rentalListingModule').component('rentalListingInitial', {
	templateUrl: 'rentalListingInitial/rentalListingInitial.html',
	bindings: {
		to: '<',
		from: '<',
		onClickNext: '&',
		imageSrc: '<',
		isMobile: '<'
	},
	controller: ['$http', function($http) {

		this.clickNext = function() {
			this.onClickNext({to: this.to});
		};
	}]
});
